import { DocumentButtons } from "PFApp/components/document_buttons";
import { UseDownloadDocument } from "PFApp/components/document_buttons/hooks/use_download_document";
import { ImportModalPageType } from "PFApp/components/import_modal/constants/import_modal_page";
import { useImportModalContext } from "PFApp/components/import_modal/contexts/import_modal_context";
import { Button } from "PFComponents/button";
import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { Import, ImportBase } from "PFTypes";
import { DocFormat } from "PFTypes/doc_format";
import { useTranslation } from "react-i18next";

import css from "./import_data_table_page.module.scss";

export type ImportDataTableHeaderProps<T extends ImportBase = Import> = {
  importData: T;
  fetchImportDocs?: UseDownloadDocument["generateDocument"];
};

export const ImportDataTableHeader = <T extends ImportBase = Import>({
  importData: {
    createdAt,
    csvAttachment: { filename }
  },
  fetchImportDocs
}: ImportDataTableHeaderProps<T>) => {
  const { setCurrentPage } = useImportModalContext<T>();
  const { formatLongDate } = useDateFormatter();
  const { t } = useTranslation();

  const goBackToHistory = () => setCurrentPage(ImportModalPageType.ImportHistory);

  return (
    <div className={css.header}>
      <Typography variant="h5" className={css.breadcrumbs}>
        <Button
          text={t("importFiles.importHistory")}
          kind="text"
          onClick={goBackToHistory}
          className={css.headerButton}
        />
        <span>
          / {formatLongDate(createdAt)} (<em>{filename}</em>)
        </span>
      </Typography>
      {fetchImportDocs && (
        <DocumentButtons
          generateDocument={fetchImportDocs}
          buttonComponent={({ onClick }) => (
            <Button onClick={() => onClick(DocFormat.Csv)} kind="secondary" icon="export" />
          )}
        />
      )}
    </div>
  );
};
